import { GetReviewSetQueryVariables } from '@app/data/shop-bff';
import { publicShopBffSdk } from '@app/utils/common';
import { useCallback, useState } from 'react';
import { Review } from 'types/shop-bff/types';

export const useReviews = () => {
  const [{ reviews, loading }, setReviews] = useState<{
    reviews: Review[] | null;
    loading: boolean;
  }>({
    reviews: [],
    loading: true,
  });

  const refresh = useCallback((variables: GetReviewSetQueryVariables) => {
    setReviews({ reviews: [], loading: true });

    publicShopBffSdk
      .GetReviewSet(variables)
      .then((res) => {
        setReviews({
          reviews: res.shop_reviewSet?.reviews || [],
          loading: false,
        });
      })
      .catch(() => {
        // TODO: Handle errors
        setReviews({
          reviews: [],
          loading: false,
        });
      });
  }, []);

  return {
    reviews,
    loading,
    refresh,
  };
};
